export default __webpack_public_path__ + "static/mockup3_fields-652ade9565ca4ff6101c07d40b4c7ca2.jpg";